import * as React from 'react'
import {
  Theme,
  createStyles,
  WithStyles,
  withStyles
} from '@material-ui/core/styles'
import { formatDate } from '../../utils/dates'
import { utcToZonedTime } from 'date-fns-tz'
import { ITicket } from '../../models/Ticket'
import { IDashboardTicket } from '../../models/Dashboard'
import { IUserCapabilities } from '../../models/User'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'

const styles = (_theme: Theme) =>
  createStyles({
    badgeRoot: {
      paddingLeft: 40
    },
    badgeStyle: {
      top: 0,
      left: 0
    },
    listItemTextRoot: {
      padding: '0 16px'
    },
    otherTicketDetails: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      [_theme.breakpoints.down('sm')]: {
        width: 200
      },
      [_theme.breakpoints.up('sm')]: {
        width: 500
      }
    },
    otherTicketDetails__section: {
      [_theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      [_theme.breakpoints.up('sm')]: {
        width: 200,
        paddingRight: 10
      }
    }
  })

export interface IOtherTicketDetailsProps
  extends IOneplaceLibraryContextProp,
    WithStyles<typeof styles> {
  ticket: IDashboardTicket | ITicket
  capabilities: IUserCapabilities
}

export const OtherTicketDetails = withStyles(styles)(
  withOneplaceLibraryContext((props: IOtherTicketDetailsProps) => {
    const {
      classes,
      ticket: { entityName, date, dueDate, statusLabel, category },
      capabilities
    } = props
    const t = props.ctx.i18next.t
    return (
      <div className={classes.otherTicketDetails}>
        <span className={classes.otherTicketDetails__section}>
          Created:{' '}
          {formatDate(
            'display_date',
            utcToZonedTime(date, capabilities.timeZone),
            capabilities.dateFormat
          )}
        </span>
        <span className={classes.otherTicketDetails__section}>
          Due: {formatDate('display_date', dueDate, capabilities.dateFormat)}
        </span>
        <span className={classes.otherTicketDetails__section}>
          For: {entityName}
        </span>
        <span className={classes.otherTicketDetails__section}>
          Status: {t('customLabel_ticketStatus' + statusLabel)}
        </span>
        <span className={classes.otherTicketDetails__section}>
          Category: {category?.name || ''}
        </span>
      </div>
    )
  })
)
